import { render, staticRenderFns } from "./ModalCreateTypeOfSchedule.vue?vue&type=template&id=2466df24&scoped=true&"
import script from "./ModalCreateTypeOfSchedule.vue?vue&type=script&lang=js&"
export * from "./ModalCreateTypeOfSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateTypeOfSchedule.vue?vue&type=style&index=0&id=2466df24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466df24",
  null
  
)

export default component.exports